import React from "react";
import Editor from "react-simple-code-editor";

// Code Highlighting
import Prism from "prismjs";
import "prismjs/components/prism-sql";
import "prismjs/themes/prism.css";

type SqlEditorProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

const SqlEditor: React.FC<SqlEditorProps> = ({ value, onChange, disabled = false }) => {
  return (
    <Editor
      value={value}
      onValueChange={onChange}
      highlight={code => Prism.highlight(code, Prism.languages.sql, "sql")}
      padding={10}
      style={{
        fontFamily: '"Fira code", "Fira Mono", monospace',
        fontSize: 14,
        border: "1px solid #dee5ed",
        borderRadius: ".375rem"
      }}
      disabled={disabled}
    />
  );
};

export default SqlEditor;
